import { DOWNLOAD_MESSAGES } from './downloadMessages';

export type DownloadNotificationKind = 'dicom' | 'jpeg';

function getNotificationService(servicesManager: AppTypes.ServicesManager) {
  return servicesManager.services.uiNotificationService;
}

export function showDownloadError(
  servicesManager: AppTypes.ServicesManager,
  message?: string
): void {
  if (!message) {
    return;
  }

  getNotificationService(servicesManager)?.show({
    title: 'Download failed',
    message,
    type: 'error',
    duration: 7000,
  });
}

export function showDownloadSuccess(
  servicesManager: AppTypes.ServicesManager,
  filename: string,
  kind: DownloadNotificationKind,
  imageCount?: number
): void {
  const countSuffix =
    typeof imageCount === 'number' && imageCount > 1 ? ` (${imageCount} images)` : '';

  const message =
    kind === 'dicom'
      ? DOWNLOAD_MESSAGES.DICOM_EXPORT_SUCCESS(filename)
      : DOWNLOAD_MESSAGES.JPEG_EXPORT_SUCCESS(filename, countSuffix);

  getNotificationService(servicesManager)?.show({
    title: 'Download started',
    message,
    type: 'success',
    duration: 5000,
  });
}

export function showExportInProgressNotice(servicesManager: AppTypes.ServicesManager): void {
  getNotificationService(servicesManager)?.show({
    title: 'Download in progress',
    message: DOWNLOAD_MESSAGES.EXPORT_IN_PROGRESS,
    type: 'info',
    duration: 3000,
  });
}
